import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import SvgIcon from '@material-ui/core/SvgIcon'
import useStyles from './styles'

const SimpleCard = props => {
  const {
    icon,
    number,
    text,
    isComplex,
    textButton,
    onClick,
    onClickCard,
  } = props

  const classes = useStyles()

  return (
    <Card
      className={clsx(
        isComplex && classes.complex,
        !isComplex && classes.simple,
      )}
      elevation={1}
    >
      {isComplex ? (
        <article className={classes.root}>
          <div className={classes.header}>
            {icon ? (
              <div className={classes.iconWrapper}>
                <SvgIcon component={icon} className={classes.icon} />
              </div>
            ) : null}
            <Typography variant="body2" component="p" className={classes.text}>
              {text}
            </Typography>
          </div>
          <div className={classes.content}>
            <Button
              className={classes.button}
              variant="contained"
              color="primary"
              size="small"
              onClick={onClick}
            >
              {textButton}
            </Button>
          </div>
        </article>
      ) : (
        <CardActionArea
          component="article"
          onClick={onClickCard}
          className={classes.root}
        >
          <div className={classes.header}>
            {icon ? (
              <div className={classes.iconWrapper}>
                <SvgIcon component={icon} className={classes.icon} />
              </div>
            ) : null}
          </div>
          <div className={classes.content}>
            <Typography variant="h1" component="p">
              {number}
            </Typography>
            <Typography variant="body2" component="p" className={classes.text}>
              {text}
            </Typography>
          </div>
        </CardActionArea>
      )}
    </Card>
  )
}

SimpleCard.propTypes = {
  icon: PropTypes.any.isRequired,
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.string,
  isComplex: PropTypes.bool,
  textButton: PropTypes.string,
  onClick: PropTypes.func,
  onClickCard: PropTypes.func,
}

export default SimpleCard
